import { Controller } from "@hotwired/stimulus"
import Toastify from 'toastify-js'

export default class extends Controller {
  connect() {
    const flashData = JSON.parse(this.element.dataset.flash);

    flashData.forEach(([type, message]) => {
      this.showToast(message, type);
    });
  }

  showToast(message, type) {
    const backgroundColors = {
      notice: "#009688",
      info: "#1ca1f1",
      alert: "#f36d27",
      error: "#f44336"
    };

    Toastify({
      text: message,
      className: "toastify-message",
      duration: 3000,
      close: true,
      offset: { x: 30, y: 20 },
      position: 'right',
      style: {
        background: backgroundColors[type] || "#ccc"
      },
    }).showToast();
  }
}
